<template>
  <fragment>
    <b-row class="mb-3">
      <b-col cols="12">
        <h2>User Emails</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form @submit.prevent="findUsers">
          <b-form-row>
            <b-col cols="12">
              <b-form-group
                label="User Ids"
                label-class="font-weight-bold"
                description="ids should be comma-separated, for example: 1,5,29,141"
                invalid-feedback="Wrong input format, please check the hint"
              >
                <b-form-textarea
                  rows="6"
                  placeholder="User Ids"
                  v-model="$v.ids.$model"
                  :state="validateState('ids')"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row class="mt-1 mb-4">
            <b-col cols="12" class="text-right">
              <b-button variant="primary" type="submit">
                Search
              </b-button>
              <b-button variant="primary" type="submit" class="ml-2" @click="onGenerateCSV" :disabled="loadingCsv">
                <b-spinner v-if="loadingCsv" small />
                <span v-else>Generate CSV</span>
              </b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mb-2">
        <h4>Result</h4>
      </b-col>
      <b-col cols="12">
        <b-table borderless :fields="fields" :items="users" :busy="loading">
          <div slot="table-busy" class="text-center my-5">
            <b-spinner class="align-middle" />
            <strong>Loading...</strong>
          </div>
        </b-table>
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import Api from '@/providers/Api';
import { validationMixin } from 'vuelidate';
import validateStateMixin from "@/mixins/validateStateMixin";
import { helpers } from 'vuelidate/lib/validators';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

const FIELDS = [{ key: 'id' }, { key: 'email' }];
const commaSeparatedIntegers = helpers.regex('commaSeparatedIntegers', /^(\d+(,\d+)*)?$/);

export default {
  name: 'UserEmailsByIds',
  mixins: [validationMixin, validateStateMixin],
  data: function () {
    return {
      ids: '',
      loading: false,
      loadingCsv: false,
      users: [],
    };
  },
  validations: {
    ids: {
      commaSeparatedIntegers
    },
  },
  computed: {
    fields: function () {
      return FIELDS;
    },
  },
  methods: {
    findUsers: async function () {
      this.loading = true;
      try {
        this.users = await Api.findUserEmailByIds(this.ids.split(','));
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loading = false;
      }
    },
    onGenerateCSV: async function () {
      this.loadingCsv = true;
      try {
        await Api.userEmailByIdsAsCsv(this.ids.split(','));
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingCsv = false;
      }
    },
  },
};
</script>

<style scoped></style>
